<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:3pc"></p>
<p class="text"><a id="page_13"></a>This is a true story. Conversations and reflections were based on hundreds of hours of interviews. In the interest of privacy, some names and details have been changed, and in one case a composite character created.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_thisistrue.vue?557d6ac5